<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.customerUserPO.headImg" v-if="info.customerUserPO && info.customerUserPO.headImg" :preview-src-list="[info.customerUserPO.headImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <span class="ml10 font16">{{info.customer.name || info.customerUserPO.userName}}</span>
        <!-- <div class="sex-box flexs"> -->
        <i style="font-size: 13px;" :class="info.customerUserPO.userName==1?'el-icon-male':'el-icon-female'" :style="{'color':info.customerUserPO.userName==1?'#60B7DC':'#F59494'}" class="ml5"></i>
        <!-- </div> -->
        <div class="font12 label-box">{{info.customerLevel.name}}</div>
      </div>
      <el-descriptions class="margin-top" title="" :column="10" direction="vertical" :colon="false" :labelStyle="{'color':'#8F8E8E','paddingBottom':'0px'}">
        <el-descriptions-item label="业务ID">{{info.customer.id || ''}}</el-descriptions-item>
        <el-descriptions-item label="用友编码">{{info.customer.code}}</el-descriptions-item>
        <el-descriptions-item label="电话">{{info.customer.pho}}</el-descriptions-item>
        <el-descriptions-item label="所在区域"><span v-if="info.addr && info.addr.length">{{info.addr[0].regionName}}{{info.addr[1].regionName}}<span v-if="info.addr.length==3">{{info.addr[2].regionName}}</span></span></el-descriptions-item>
        <el-descriptions-item label="体验班分润比例">{{info.customer.incomeRatio2 || 0}}%</el-descriptions-item>
        <el-descriptions-item label="研修班分润比例">{{info.customer.incomeRatio2 || 0}}%</el-descriptions-item>
        <el-descriptions-item label="上级" :span="2" v-if="info.customer.clevel!=1"><span>{{info.line.name}}【{{info.lineLevel.name}}】{{info.line.pho}}</span>
        </el-descriptions-item>
        <el-descriptions-item label="关联城市公司" v-if="info.customer.clevel==3 && info.cityCompany">{{info.cityCompany.name}}</el-descriptions-item>
        <el-descriptions-item label="下级团队人数">{{info.childCount}}</el-descriptions-item>
        <el-descriptions-item label="客户人数">{{info.childCustomerCount}}</el-descriptions-item>
        <el-descriptions-item label="业务权限">{{info.customer.state?'已授权':'未授权'}}</el-descriptions-item>
        <!-- <el-descriptions-item label="注册app时间">{{info.firstLoginAppTime}}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="注册时身份">{{info.levelName}}</el-descriptions-item> -->
        <el-descriptions-item label="状态">{{info.customer.isDeparted==0?'在职':info.customer.isDeparted==2?'离职交接中':'离职'}}</el-descriptions-item>
        <el-descriptions-item label="管辖区域" v-if="info.areaCount"><span class="c-main c-pointer" @click="showArea">查看管辖区域</span></el-descriptions-item>
        <el-descriptions-item label="修改身份原因" :span="3" v-if="info.customer.lastDonote">{{info.customer.lastDonote}}</el-descriptions-item>
        <el-descriptions-item label="修改身份附件" :span="4" v-if="lastApplyVoucherList.length">
          <el-image
            v-for="(url, idx) in lastApplyVoucherList"
            :key="idx"
            style="width: 60px; height: 60px; margin-right: 8px;"
            :src="url"
            :preview-src-list="lastApplyVoucherList"
            fit="cover"
          ></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-tabs v-model="activeType" @tab-click="handleCheck" class="mt20 ">
        <el-tab-pane label="基础信息" name="0"></el-tab-pane>
        <el-tab-pane label="他的客户" name="1" v-if="!info.customer.isDeparted"></el-tab-pane>
        <el-tab-pane label="他的团队" name="2" v-if="!info.customer.isDeparted"></el-tab-pane>
        <el-tab-pane label="他的业绩" name="3"></el-tab-pane>
        <el-tab-pane label="他的佣金" name="4" v-if="info.customer.clevel==3"></el-tab-pane>
      </el-tabs>
      <!-- <Title class="mt20">{{activeType==0?'其他信息':'统计'}}</Title>
      <template v-if="activeType==0">
        <el-descriptions class="margin-top" title="" :column="3">
          <el-descriptions-item label="注册APP时间">{{info.firstLoginAppTime}}</el-descriptions-item>
          <el-descriptions-item label="入职时间">{{info.resignTime}}</el-descriptions-item>
          <el-descriptions-item label="离职时间" v-if="info.state==30">{{info.resignTime}}</el-descriptions-item>
        </el-descriptions>
      </template> -->
      <template v-if="activeType==0">
        <Title class="mt40">实名认证：<span :style="{'color': info.customerCertificates?'#0D862F':'#E73F3F'}">{{info.customerCertificates?'已认证':'未认证'}}</span>
        </Title>
        <el-descriptions title="" v-if="info.customerCertificates && info.customerCertificates.certificatesType==1">
          <el-descriptions-item label="认证类型">企业认证</el-descriptions-item>
          <el-descriptions-item label="门店类型">{{getCompanyTypeName(info.customerCertificates.companyType)}}</el-descriptions-item>
          <el-descriptions-item label="企业全称">{{info.customerCertificates.companyName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="所在地">{{info.customerCertificates.companyType}}</el-descriptions-item> -->
          <el-descriptions-item label="资质证件类型">{{info.customerCertificates.companyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码">{{info.customerCertificates.code}}</el-descriptions-item>
          <el-descriptions-item label="纳税人识别号">{{info.customerCertificates.taxpayerCode}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.customerCertificates.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="资质证件">
            <el-image style="width: 150px;" :src="info.customerCertificates.certificatesImg" :preview-src-list="[info.customerCertificates.certificatesImg]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" v-if="info.customerCertificates && info.customerCertificates.certificatesType==2">
          <el-descriptions-item label="认证类型">个人认证</el-descriptions-item>
          <el-descriptions-item label="姓名">{{info.customerCertificates.companyName}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.customerCertificates.code}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.customerCertificates.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-image style="width: 150px;" :src="info.customerCertificates.certificatesImg.split(',')[0]" :preview-src-list="info.customerCertificates.certificatesImg.split(',')"></el-image>
            <el-image style="width: 150px;" class="ml10" :src="info.customerCertificates.certificatesImg.split(',')[1]" :preview-src-list="info.customerCertificates.certificatesImg.split(',')"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">其他信息</Title>
        <el-descriptions title="">
          <el-descriptions-item label="注册app时间">{{info.customerUserPO.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="业务权限开通时间">{{info.customer.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="观察时间" v-if="info.customer.isIntern">{{info.customer.ywInternTime}}</el-descriptions-item>
          <el-descriptions-item label="是否开通提现">{{info.tongshangyun?'是':'否'}}</el-descriptions-item>
          <el-descriptions-item label="入职时间" v-if="info.customer.clevel==3">{{info.customer.isareatime}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-if="activeType!=0">
        <!-- <div class="flexs" v-if="[2,4].includes(activeType)">
          <el-radio-group v-model="radio1">
            <el-radio-button label="全部"></el-radio-button>
            <el-radio-button label="今日"></el-radio-button>
            <el-radio-button label="本周"></el-radio-button>
            <el-radio-button label="本月"></el-radio-button>
          </el-radio-group>
        </div> -->
        <el-row>
          <el-col :span="8" v-for="(item,index) in statisticsList" :key="index" style="margin-bottom: 40px;">
            <div class="grid-content">
              <div>{{item.label}}</div>
              <div class="flexs justify-between">
                <span><span style="font-size: 50px;">{{item.value || 0}}</span>{{item.unit}}</span>
                <!-- <i class="el-icon-arrow-right" style="font-size: 30px;color: #878787;font-weight: bold;"></i> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-card>
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <div class="dialog-box">
        <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import clientAreaApi from '@/api/client/clientArea'
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
import clientListApi from '@/api/client/clientList'
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
export default {
  props: ['rowId'],
  data() {
    return {
      radio1: '全部',
      activeType: '0',
      list: [],
      formVisible: false,
      info: {
        userHeadImg: '',
        customerUserPO: {},
        line: {},
        customerLevel: {},
        lineLevel: {},
        customer: {}
      },
      technicalState: 1,
      shareData: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      statisticsList: []
    }
  },
  computed: {
    // customer.last_apply_voucher 存的是逗号分隔的 url
    lastApplyVoucherList() {
      const raw = this.info && this.info.customer && this.info.customer.lastApplyVoucher
      return raw ? raw.split(',').filter(i => i) : []
    }
  },
  async created() {
    this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串（非数字），直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    handleShow() {
      clientListApi.fetchById(this.rowId)
        .then((data) => {
          this.info = data.data;
          
          // this.getServiceNum()
          // this.getClientNum()
          console.log('this.form: ', this.info);
        })
    },
    showArea() {
      if (this.info.areaCount) this.changeIdentity()
      
    },
    // 获取地区
    changeIdentity() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      clientAreaApi.fetchTreeList({
        customerId: this.rowId,
        parentCustomerId: this.info.customer.parentId,
        addOrDelete: 2,
        v: 3
      }).then(({
        data
      }) => {
        this.areaOptions = data
        this.loading.close()
        this.formVisible = true
      }).catch(() => {
        this.loading.close()
        })
    },
    // 切换
    async handleCheck() {
      if (this.activeType == '1') {
        this.statisticsList = [{label: '普通客户',key: '8',unit: '人',value: 0},
        {label: '体验班',key: '7',unit: '人',value: 0},
        {label: '研修班',key: '6',unit: '人',value: 0},]
        // this.getClientNum()
      }
      if (this.activeType == '2') {
        this.statisticsList = [{label: '营销经理',key: '2',unit: '人',value: 0},
        {label: '大区经理',key: '3',unit: '人',value: 0},
        {label: '地区经理',key: '4',unit: '人',value: 0},
        {label: '县区经理',key: '5',unit: '人',value: 0}]
        // this.getServiceNum()
      }
      if (this.activeType == '3') {
        this.statisticsList = [{label: '总业绩',key: 'performance',unit: '元',value: 0},
        {label: '直属客户业绩',key: 'performanceForCustomer',unit: '元',value: 0},
        {label: '团队业绩',key: 'performanceForChild',unit: '元',value: 0}]
        // this.getChildNum()
      }
      if (this.activeType == '4') {
        this.statisticsList = [{label: '累计佣金',key: 'sumCommissionMoney',unit: '元',value: 0},
        {label: '预计佣金',key: 'ygCommissionMoney',unit: '元',value: 0},
        {label: '已提现佣金',key: 'withdrawnCommission',unit: '元',value: 0},
        {label: '可提现佣金',key: 'commissionMoney',unit: '元',value: 0}]
      }
      if (['1', '2'].includes(this.activeType)) {
        let arr = await this.getClientNum()
        console.log('arr: ', arr);
        this.statisticsList.map(item => {
          item.value = arr.find(it => it.level == item.key).childCount
          return item
        })
      }
      if (['4'].includes(this.activeType)) {
        let obj = await this.getCommissionNum()
        this.statisticsList.map(item => {
          item.value = obj[item.key]
          return item
        })
      }
      if (['3'].includes(this.activeType)) {
        let obj = await this.getPerformances()
        this.statisticsList.map(item => {
          item.value = obj[item.key]
          return item
        })
      }
    },
    // async getNum(){
    //   const {data} = await
    // },
    // 获取业绩
    async getPerformances() {
      const {
        data
      } = await clientListApi.getPerformance(this.rowId)
      // console.log('业绩: ',data);
      return data
    },
    // 获取佣金
    async getCommissionNum() {
      const {
        data
      } = await managecustomerwalletApi.findCommissionTotalByCustomerId({
        customerId: this.rowId
      })
      return data
    },
    // 获取预约服务数量
    async getServiceNum() {
      const {
        data
      } = await technicianServiceOrderApi.getStatusCount({
        technicianInfoId: this.rowItem.id
      })
      // console.log('服务数量: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
          this.statisticsList[0].value = data.reduce((total, current) => {
            return total + current.count
          }, 0)
        })
        console.log('this.statisticsList: ', this.statisticsList);
      }
    },
    // 获取客户数量
    async getClientNum() {
      const {
        data
      } = await clientListApi.findChildCount({
        customerId: this.rowId
      })
      return data
    },
    // 获取团队数量
    async getChildNum() {
      const {
        data
      } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.dialog-box {
  max-height: 70vh;
  overflow-y: auto;
}
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
